module.exports = __webpack_public_path__ + "img/godo_pc_01.9df8e70f.png";